import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingImageSplitterConfig } from '@/data/landingConfig/landingImageSplitterConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageSplitter } from './schemaObject';

interface Props {}
const ImageSplitter: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelImageSplitterV2,
		},
		GenerateLandingLinkService.funnelImageSplitter,
	);

	return (
		<>
			<AggregateSchema schema={schemaObject_ImageSplitter} />
			<LandingTemplate
				data={landingImageSplitterConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default ImageSplitter;
